<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Orders",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Orders",
            items: [
               {
                  text: "Orders",
                  active: true,
               },                   
            ],

            orders: [],   
            drivers: [],

            assign_driver: {
               order_id: '',
               driver_id: ''
            },
            customer_order_id: '',
            
            pagination: {},
            from: null,
            to: null,
            total: null,
            
            keyword: "",
            listing_length: 10,
            status: '',
            token: "",
            errors: {},          
            active_page_url: null,

            cancel: {
               order_id: '',
               reason: ''
            },
            user:{},
            subadmin_modules:[], 
         };
      },
      mounted() {
         this.fetchSubadminModules();
         this.fetchUser();
      },

      created() {
         this.fetchOrders();
      },


      methods: {
         fetchSubadminModules(){
            if (localStorage.getItem('subadmin_modules')) {
               this.subadmin_modules =  JSON.parse(localStorage.getItem('subadmin_modules'));
               console.log(this.subadmin_modules);
            }
        },
        fetchUser(){
            if (localStorage.getItem('sigofuel_admin')) {
               this.user =  JSON.parse(localStorage.getItem('sigofuel_admin'));
               console.log(this.user);
            }
        },
        checkPrivilege(module_id){
            // console.log(label);
            // alert('module:'+module_id+' label:'+label);
            if(this.user.role_id == 1){
                return true;
            }else{
                if(module_id){
                    if(this.subadmin_modules.includes(module_id)){
                        return true;
                    }else{
                        return false;
                    }
                }else{
                    return true;
                }
            }
        },
         fetchOrders(page_url = null) {

            this.getToken();
            let url = "api/admin/orders?keyword=" + this.keyword + "&limit=" + this.listing_length + "&status=" + this.status;

            page_url = page_url || url;

            if(localStorage.back_url) {
               page_url = localStorage.back_url;  
               localStorage.removeItem('back_url');
            }    

            this.active_page_url = page_url;
            this.loading = true;
            
            this.$axios
               .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  if(res.status == 200) {
                     var responseData = res.data.data;
                     console.log(responseData);
                     this.orders = responseData.Orders.data;
                     
                     
                     this.pagination = responseData.Orders.links;
                     this.from = responseData.Orders.from;
                     this.to = responseData.Orders.to;
                     this.total = responseData.Orders.total;
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .catch((error) => {
               if (error.response) {
                  if(error.response.status == 422) {               
                     if (error.response.data) {
                        this.errors = error.response.data.message;
                     } 
                     this.$swal("", error.response.statusText, "error");
                     
                  } else if(error.response.status == 500) {
                     this.$swal("", error.response.statusText, "error");

                  } else if(error.response.status == 401) {
                     this.$swal("", error.response.statusText, "error");
                     this.$router.push({ name: "login" });
                     
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               } else {
                  this.$swal("", error.message, "error");
               }
            })
            .finally(() => (this.loading = false));
         }, 

         getToken() {
            if (localStorage.getItem('sigofuel_admin')) {
               var sigofuel_admin =  JSON.parse(localStorage.getItem('sigofuel_admin'));
               if(sigofuel_admin.token) {
                  this.token = sigofuel_admin.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         }, 

         showModal(modal) {
            this.$refs[modal].show();
         },

         hideModal(modal) {
            this.$refs[modal].hide();
         },    

         fetchStationDrivers(order) {
            this.assign_driver.order_id = order.customer_order_id;
            let url = "api/admin/getonlineDrivers?fuel_station_id=" + order.fuel_station_id;         
            this.getToken();
            this.$axios
            .get(url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.drivers = responseData.drivers;
                  this.showModal('assign-modal');
            })
            .catch((err) => console.log(err));
            
         },

         assignDriver() {
            this.getToken();           
            
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "api/admin/order/assignDriver";

            let formData = new FormData();
            formData.append("order_id", this.assign_driver.order_id);
            formData.append("driver_id", this.assign_driver.driver_id);

            this.loading = true;
            
            this.$axios
            .post(url, formData, config)
            .then((response) => {
               if(response.status == 200) {
                  this.$swal("", response.data.message, "success");        
               }
                  
               this.hideModal('assign-modal');
               this.fetchOrders(this.active_page_url);
            })
            .catch((error) => {
               if (error.response) {
                  if(error.response.status == 422) {               
                     if (error.response.data) {
                        this.errors = error.response.data.message;
                     } 
                     this.$swal("", error.response.statusText, "error");
                     
                  } else if(error.response.status == 500) {
                     this.$swal("", error.response.statusText, "error");

                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               } else {
                  this.$swal("", error.message, "error");
               }
            })
            .finally(() => (this.loading = false));
         },

         clearForm() {           
           
            this.assign_driver.order_id = "";
            this.assign_driver.driver_id = "";

            this.cancel.order_id = "";
            this.cancel.reason = "";

            this.drivers = [];
            this.errors = {};
         },

         setCancel(order_id) {
            this.cancel.order_id = order_id;
            this.showModal('cancel-modal');
         },

         cancelOrder() {
            this.getToken();           
            
            const config = {
               headers: {
                  "Content-type": "application/json",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            // let formData = new FormData();
            // formData.append("order_id", this.cancel.order_id); 
            // formData.append("reason", this.cancel.reason); 
                 
            let url = "api/admin/order/cancelOrder?order_id=" + this.cancel.order_id + "&reason=" + this.cancel.reason;
            this.$axios
            .get(url, config)
            .then((response) => {
               if (response.data.status) {
                  this.$swal("", response.data.message, "success");
               } else {
                  this.$swal("", response.data.message, "error");
               }
               this.hideModal('cancel-modal');
               this.fetchOrders(this.active_page_url);
            })
            .catch((error) => {
               if (error.response) {
                  if (error.response.data.message) {
                     this.errors = error.response.data.message;
                     //console.log(this.errors);
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               } else {
                  this.$swal("", "Something went wrong", "error");
               }
            })
            .finally(() => (this.loading = false));
         },


         download(order) {
         this.customer_order_id = order.customer_order_id;
         
         let url = "api/admin/order/invoice?id=" + this.customer_order_id;   

         const config = {
            headers: {
               "Content-type": "application/json",
               "Accept": "application/json",
               "Authorization": "Bearer " + this.token,
            },
            responseType: "arraybuffer",
         };
         // var data = JSON.stringify({
         //    "fuel_station": this.fuel_station_id,
         //    "from_date": this.from_date,
         //    "to_date": this.to_date,

         // });
         this.getToken();

         this.$axios
         .get(url, config)
         .then((response) => {
            //console.log(response);
            let blob = new Blob([response.data], { type: "application/pdf" });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
         
            let filename = "invoice" + "-" + this.customer_order_id + ".pdf";


            link.download = filename;
            link.click();
                  
         })
         .catch((error) => {
         console.log(error);
         console.log(error.response);
         if (error.response) {
         if(error.response.status == 422) {               
            if (error.response.data) {
               this.errors = error.response.data.message;
            } 
            this.$swal("", error.response.statusText, "error");
            
         } else if(error.response.status == 500) {
            this.$swal("", error.response.statusText, "error");
         } 
         else if(error.response.status == 401) {
            this.$swal("", error.response.statusText, "error");
            this.$router.push({ name: "login" });
         } else {
            this.$swal("", "Something went wrong", "error");
         }
         } else {
         this.$swal("", error.message, "error");
         }

         });
         //.finally(() => (this.loading = false));
         },

      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">
                        <router-link :to="{ name: 'orders.add' }" class="btn btn-primary float-end">Create Order</router-link>
                     </div>
                  </div>
                  <!----- top button area ends---->

                  <!----- Listing length and search starts ----->
                  <div class="row mb-3">
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-length" >
                           <label
                              >Show
                              <select class="form-control" v-model="listing_length" @change="fetchOrders()">
                                 <option value="5">5</option>
                                 <option value="10">10</option>
                                 <option value="15">15</option>
                              </select>
                              entries
                           </label>
                        </div>                        
                     </div>
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-filter">
                           <label>
                              <input type="text" class="form-control" placeholder="Search" v-model="keyword" @keyup="fetchOrders()"/>
                           </label>
                        </div>                     
                        <div class="listing-filter me-2">
                           <label>
                              <select class="form-control" v-model="status" @change="fetchOrders()">    
                                 <option value="">All</option>        
                                 <option value="1">Pending</option>
                                 <option value="2">Accepted</option>
                                 <option value="3">Ongoing</option>
                                 <option value="4">Scheduled</option>
                                 <option value="5">Delivered</option>
                                 <option value="6">Cancelled</option>
                                 <option value="7">Missed</option>
                              </select>
                           </label>
                        </div>   
                     </div>
                  </div>
                  <!----- Listing length and search ends ----->

                  <!---- listing table starts -------->
                  <div class="table-responsive">
                     <table class="table table-bordered mb-0">
                        <thead class="table-light">
                           <tr>
                              <th>Order ID</th>   
                              <th>Customer</th>
                              <th>Driver</th>
                              <th>Fuel Station</th>
                              <th>Amount</th>
                              <th>Status</th>
                              <th>Created on</th>
                              <th>Options</th>
                           </tr>
                        </thead>
                        <tbody v-if="Boolean(orders.length)">
                           <tr v-for="(order) in orders" :key="order.customer_order_id">
                              <td>#{{order.customer_order_id}}</td>
                              <td>
                                 {{order.customer_name_en}}<br>
                                 {{order.customer_country_code}} {{order.customer_mobile}}<br>
                                 {{order.customer_email}}
                              </td>                 
                              <td>
                                 {{order.driver_name_en}}</td>
                              <td> 
                                 {{order.fuel_station_name_en}}
                              </td>
                              <td>${{order.total}}</td>
                              <td>
                                 <span v-if="order.status==1" class="badge rounded-pill bg-info">Pending</span>
                                 <span v-if="order.status==2" class="badge rounded-pill bg-primary">Accepted</span>
                                 <span v-if="order.status==3" class="badge rounded-pill bg-warning">Ongoing</span>
                                 <span v-if="order.status==4" class="badge rounded-pill bg-secondary">Scheduled</span>
                                 <span v-if="order.status==5" class="badge rounded-pill bg-success">Delivered</span>
                                 <span v-if="order.status==6" class="badge rounded-pill bg-danger">Cancelled</span>
                                 <span v-if="order.status==7" class="badge rounded-pill bg-dark">Missed</span>
                              </td>
                              <td>{{order.converted_created_at}}</td>
                             
                              <td>
                                 <router-link :to="{ name: 'orders.details', params: {id: order.customer_order_id} }" class="btn btn-primary me-2 mb-2 btn-sm">Details</router-link>

                                 <b-button v-if="order.status==1 || order.status==4" variant="primary" class="btn btn-sm me-2 mb-2" :class="checkPrivilege(4) ? '' : 'd-none'" @click="fetchStationDrivers(order)" >Assign Driver</b-button>

                                 <b-button v-if="order.status==1 || order.status==2 || order.status==3 || order.status==4" variant="danger" class="me-2 mb-2 btn-sm" @click="setCancel(order.customer_order_id)">Cancel</b-button>

                                 <b-button v-if="order.status==5" variant="primary" class="btn btn-sm me-2 mb-2"   @click="download(order)">Invoice</b-button>
                              </td>
                           </tr>
                 
                        </tbody>
                        <tbody v-else>
                           <tr>
                              <td colspan="8" class="text-center">No orders found</td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
                  <!---- listing table ends -------->

                  <!----pagination starts --->     
                  <caption v-if="Boolean(orders.length)" class="float-start mt-4 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>               
                  <ul class="pagination pagination-rounded mt-4 float-lg-end d-md-inline-flex">
                     <li class="page-item "  v-bind:class="[{disabled: !page.url}, {active: page.active}]" v-for="(page, index) in pagination" :key="page.label">
                        <a href="#" class="page-link" @click.prevent="fetchOrders(page.url + '&limit='+ listing_length + '&status=' + status + '&keyword=' + keyword + '&fuel_station_id=' + $route.params.id )">
                           <i v-if="index == 0" class="mdi mdi-chevron-left"></i>
                           <i v-else-if="index == pagination.length-1" class="mdi mdi-chevron-right"></i>
                           <span v-else>{{page.label}}</span>                          
                        </a>
                     </li>
                  </ul>
                  <!----pagination ends --->


               </div>
            </div>
         </div>
      </div>

      <!---- modal starts ---->
      <b-modal ref="assign-modal" id="assign-modal" title="Assign Driver" hide-footer>
         <b-form @submit.prevent="assignDriver()">
            <b-row>                          

               <b-col md="12" class="form-group">
                  <label class="control-label">Driver<span class="text-danger">*</span></label>
                  <select class="form-control" v-model="assign_driver.driver_id">
                     <option value="">Select</option>
                     <option :value="driver.user_id" v-for="driver in drivers" :key="driver.user_id">{{driver.name_en}}</option>
                  </select>
                  
               </b-col>                           
                           
               <b-col md="12">
                  <b-button type="submit" class="me-3" variant="primary">Save</b-button>
                  <b-button class="" variant="light" @click="hideModal('assign-modal')">Close</b-button>
               </b-col>
            </b-row>
         </b-form>
      </b-modal>
      <!---- modal ends ----->

      <!---- modal starts ---->
      <b-modal ref="cancel-modal" id="cancel-modal" title="Cancel Order" hide-footer @hidden="clearForm()">
         <b-form @submit.prevent="cancelOrder()">
            <b-row>  

               <b-col lg="12" class="form-group">
                  <label class="control-label">Reason<span class="text-danger">*</span></label>
                  <b-form-input  v-model="cancel.reason"></b-form-input>
                  
                  <div v-for="(val, index) in errors.reason" :key="index" class="invalid-feedback">
                     <p class="mb-0">{{ val }}</p>
                  </div>
               </b-col>              
               
               <b-col lg="12">
                  <b-button type="submit" class="me-3" variant="primary">Save</b-button>
                  <b-button class="" variant="light" @click="hideModal('cancel-modal')">Close</b-button>
               </b-col>
            </b-row>
         </b-form>
      </b-modal>
      <!---- modal ends ----->
   </Layout>
</template>
